import { useAuth0 } from "@auth0/auth0-react";
import "./UserProfile.scss";
export const UserProfile = () => {
  const { user, } = useAuth0();
  return (
    <div className="user-profile">
      <div className="user-profile-avatar">
        <img src={user?.picture} alt={user?.name}/>
      </div>
      <div className="user-profile-info">
        <div className="user-profile-info-name">{user?.name}</div>
        <div className="user-profile-info-email">{user?.email}</div>
      </div>
    </div>
  )
}